import { convert } from "./utils/encrypt";

/**
 * Enum-like to define checkout option step
 */
export const CHECKOUT_STEP = Object.freeze({
  begin_checkout: "begin_checkout",
  add_payment_info: "add_payment_info",
  purchase: "purchase"
});

export const PAYMENT_TYPE = Object.freeze({
  card: "Cartão de Crédito",
  pix: "PIX",
  nupay: "Nupay"
});

export function GtmFactory (dataLayer = window.dataLayer || []) {
  const sendDataLayer = (eventType, payload) => {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: eventType,
      ecommerce: payload
    });
  };

  const buildPayload = async (data, paymentType) => {
    const fullName = data.fullName || "";
    const phone = getPhone(data.phone);
    const email = data.email?.toLowerCase() || "";

    const ecommerce = {
      currency: "BRL",
      value: data.totalAmount,
      items: [
        {
          index: 0,
          item_id: data.productId,
          item_name: data.productName,
          coupon: data.coupon || "",
          currency: "BRL",
          discount: data.discount || 0,
          price: data.price,
          quantity: 1
        }
      ],
      fullName,
      hashed_full_name: await convert(fullName.replace(/\s/g, "").toLowerCase()),
      email,
      hashed_email: await convert(email),
      phone,
      hashed_phone: await convert(phone)
    };

    if (paymentType) ecommerce.paymentType = paymentType;
    if (data.transactionId) ecommerce.transaction_id = data.transactionId;

    return ecommerce;
  };

  return {
    dataLayer,
    /**
     * Send any Event
     * @param {String} eventType
     * @param {Object.<string, any>} productData
     * @param {String} paymentType
     */
    async sendEvent (eventType, productData, paymentType) {
      sendDataLayer(eventType, await buildPayload(productData, paymentType));
    },
    /**
     * Sends analytics data about initializing the checkout page
     */
    sendBeginCheckout ({ price, discount, productId, productName, coupon, fullName, email, phone }) {
      return this.sendEvent(CHECKOUT_STEP.begin_checkout, {
        totalAmount: price,
        productId,
        productName,
        price,
        discount,
        coupon,
        fullName,
        email,
        phone
      });
    },
    registerCheckoutOptionEvent (paymentMethod, formsValues) {
      const {
        price,
        discount,
        coupon,
        productName,
        productId,
        fullName,
        email,
        phone
      } = formsValues;

      const eventData = {
        price,
        discount,
        coupon,
        productName,
        productId,
        fullName,
        email,
        phone,
        totalAmount: price
      };

      return this.sendEvent(CHECKOUT_STEP.add_payment_info, eventData, paymentMethod);
    },
    registerPurchaseEvent (paymentMethod, formsValues) {
      // The payment succeeded!
      const {
        coupon,
        discount,
        productName,
        productId,
        price,
        transactionId,
        fullName,
        email,
        phone
      } = formsValues;

      const purchaseData = {
        transactionId, // Transaction ID. Required for purchases and refunds.
        coupon,
        discount,
        productId,
        productName,
        price,
        fullName,
        email,
        phone,
        totalAmount: price
      };

      return this.sendEvent(CHECKOUT_STEP.purchase, purchaseData, paymentMethod);
    }
  };
}

function getPhone (phone) {
  if (phone === "" || phone === undefined) {
    return "";
  } else {
    return `55${phone.replace(/[^0-9]/g, "")}`;
  }
}
